<template>
  <div>
    <div class="row stats-row">
      <div
        class="col-12 col-sm-6 col-xl-3 stats-col"
        v-for="stats in statsCards"
        :key="stats.title"
      >
        <div class="dashboard-stat-card">
          <div class="dashboard-stat-header" :class="`dashboard-stat-${stats.type}`">
            <img
              v-if="stats.coinImg"
              src="/img/rubinicoin.png"
              alt="Rubini Coin"
              class="dashboard-stat-icon-img"
            />
            <i v-else :class="stats.icon" class="dashboard-stat-icon"></i>
          </div>
          <div class="dashboard-stat-body">
            <p class="dashboard-stat-title">{{ stats.title }}</p>
            <span class="dashboard-stat-value">{{ stats.value }}</span>
          </div>
          <div class="dashboard-stat-footer">
            <img
              v-if="stats.coinImg"
              src="/img/rubinicoin.png"
              alt=""
              class="dashboard-stat-footer-icon"
            />
            <i v-else :class="stats.footerIcon"></i>
            <span class="dashboard-stat-footer-text">{{ stats.footerText }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row vocation-row">
      <div class="col-12">
        <div class="vocation-section-card">
          <h2 class="vocation-section-title">Média de preço por classe</h2>
          <div class="vocation-grid">
            <div
              class="vocation-col"
              v-for="v in vocationCards"
              :key="v.name"
            >
              <div class="vocation-card">
                <div class="vocation-card-header">
                  <img
                    :src="v.imgSrc"
                    :alt="v.name"
                    class="vocation-sprite"
                  />
                  <h3 class="vocation-name">{{ v.name }}</h3>
                </div>
                <div class="vocation-card-body">
                  <div class="vocation-stats-row vocation-stats-main">
                    <div class="vocation-stat rubini-coins">
                      <span class="vocation-stat-tag">
                        <img src="/img/rubinicoin.png" alt="" class="vocation-coin-icon" /> RC
                      </span>
                      <span class="vocation-stat-value vocation-stat-value-main">{{ v.avgPrice }}</span>
                      <span class="vocation-stat-sublabel">média de preço vendido</span>
                    </div>
                    <div class="vocation-stat level">
                      <span class="vocation-stat-tag">Lvl</span>
                      <span class="vocation-stat-value vocation-stat-value-main">{{ v.avgLevel }}</span>
                      <span class="vocation-stat-sublabel">média de level vendido</span>
                    </div>
                  </div>
                  <div class="vocation-sold">
                    <span class="vocation-sold-value">{{ v.count }}</span>
                    <span class="vocation-sold-label">vendidos</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row records-row">
      <div class="col-12">
        <div class="records-card">
          <h2 class="records-title">Recordes de vendas</h2>
          <div class="records-grid">
            <div
              v-for="(record, idx) in recordEntries"
              :key="record ? record.key : 'empty-' + idx"
              class="record-item"
              :class="{ 'record-empty': !record }"
            >
              <template v-if="record">
                <div class="record-label">{{ record.label }}</div>
                <div class="record-name">{{ record.characterName || "—" }}</div>
                <div class="record-meta">
                  <span v-if="record.vocation">{{ record.vocation }}</span>
                  <span v-if="record.level != null"> · Lvl {{ record.level }}</span>
                  <span v-if="record.world"> · {{ record.world }}</span>
                </div>
                <div class="record-price">
                  <img src="/img/rubinicoin.png" alt="" class="record-coin-icon" />
                  {{ record.bidValue != null ? record.bidValue.toLocaleString("pt-BR") : "—" }} RC
                </div>
                <div v-if="record.skillName && record.skillLevel != null" class="record-skill">
                  {{ record.skillName }}: {{ record.skillLevel }}
                </div>
              </template>
              <template v-else>
                <div class="record-label record-placeholder">Sem dados</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAuctionsCurrent, getAuctionsHistory, getAuctionsStats, getAuctionsRecords } from "@/api.js";

export default {
  components: {},
  data() {
    return {
      loading: true,
      error: null,
      statsCards: [
        {
          type: "info",
          icon: "ti-view-list-alt",
          title: "Leilões ativos",
          value: "—",
          footerText: "Em andamento",
          footerIcon: "ti-timer",
        },
        {
          type: "success",
          icon: "ti-check",
          title: "Leilões finalizados",
          value: "—",
          footerText: "Histórico",
          footerIcon: "ti-calendar",
        },
        {
          type: "warning",
          icon: "ti-wallet",
          title: "Média de preço",
          value: "—",
          footerText: "Rubini Coins",
          footerIcon: "ti-stats-up",
          coinImg: true,
        },
        {
          type: "primary",
          icon: "ti-user",
          title: "Personagens transacionados",
          value: "—",
          footerText: "Total vendidos",
          footerIcon: "ti-link",
        },
      ],
      vocationCards: [
        { name: "Elder Druid", slug: "druid", count: "—", avgPrice: "—", avgLevel: "—", imgSrc: "/img/vocations/druid.gif" },
        { name: "Master Sorcerer", slug: "sorcerer", count: "—", avgPrice: "—", avgLevel: "—", imgSrc: "/img/vocations/sorcerer.gif" },
        { name: "Elite Knight", slug: "knight", count: "—", avgPrice: "—", avgLevel: "—", imgSrc: "/img/vocations/knight.gif" },
        { name: "Royal Paladin", slug: "paladin", count: "—", avgPrice: "—", avgLevel: "—", imgSrc: "/img/vocations/paladin.gif" },
        { name: "Exalted Monk", slug: "monk", count: "—", avgPrice: "—", avgLevel: "—", imgSrc: "/img/vocations/monk.gif" },
      ],
      records: null,
    };
  },
  computed: {
    recordEntries() {
      if (!this.records) return [null, null, null, null, null];
      const keys = [
        "mostExpensive",
        "mageHighestMagic",
        "knightHighestWeapon",
        "monkHighestFist",
        "paladinHighestDistance",
      ];
      return keys.map((key) => {
        const r = this.records[key];
        if (!r || r.label == null) return null;
        return { key, ...r };
      });
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      this.error = null;
      try {
        const [currentRes, historyRes, statsRes] = await Promise.all([
          getAuctionsCurrent({ page: 1, size: 1 }),
          getAuctionsHistory({ page: 1, size: 1 }),
          getAuctionsStats(),
        ]);
        this.statsCards[0].value = currentRes.total ?? 0;
        this.statsCards[1].value = historyRes.total ?? 0;
        this.statsCards[2].value = statsRes.overall?.avgPrice != null ? statsRes.overall.avgPrice.toLocaleString("pt-BR") : "—";
        this.statsCards[3].value = statsRes.overall?.count ?? 0;

        const vocationSlugs = [
          { name: "Elder Druid", slug: "druid" },
          { name: "Master Sorcerer", slug: "sorcerer" },
          { name: "Elite Knight", slug: "knight" },
          { name: "Royal Paladin", slug: "paladin" },
          { name: "Exalted Monk", slug: "monk" },
        ];
        this.vocationCards = vocationSlugs.map(({ name, slug }) => {
          const data = statsRes.byVocation?.[name] || {};
          const count = data.count ?? 0;
          const avgPrice = data.avgPrice != null ? data.avgPrice.toLocaleString("pt-BR") : "—";
          const avgLevel = data.avgLevel != null ? String(Math.round(data.avgLevel)) : "—";
          return {
            name,
            slug,
            count,
            avgPrice,
            avgLevel,
            imgSrc: `/img/vocations/${slug}.gif`,
          };
        });

        try {
          this.records = await getAuctionsRecords();
        } catch (_) {
          this.records = null;
        }
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.stats-row {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  margin-bottom: 1.5rem;
}

.stats-row .stats-col {
  display: flex;
  margin-bottom: 1rem;
}

.dashboard-stat-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 180px;
  background: linear-gradient(180deg, #2a2520 0%, #1c1916 100%);
  border: 2px solid #8b6914;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(139, 105, 20, 0.2);
  overflow: hidden;
}

.dashboard-stat-header {
  flex-shrink: 0;
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid rgba(139, 105, 20, 0.4);
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-stat-header.dashboard-stat-info {
  background: linear-gradient(180deg, rgba(0, 123, 255, 0.2) 0%, transparent 100%);
}

.dashboard-stat-header.dashboard-stat-success {
  background: linear-gradient(180deg, rgba(40, 167, 69, 0.2) 0%, transparent 100%);
}

.dashboard-stat-header.dashboard-stat-warning {
  background: linear-gradient(180deg, rgba(212, 175, 55, 0.2) 0%, transparent 100%);
}

.dashboard-stat-header.dashboard-stat-primary {
  background: linear-gradient(180deg, rgba(100, 80, 180, 0.2) 0%, transparent 100%);
}

.dashboard-stat-icon {
  font-size: 2.5rem;
  color: #d4af37;
}

.dashboard-stat-icon-img {
  max-height: 2.5rem;
  width: auto;
  object-fit: contain;
}

.dashboard-stat-body {
  flex: 1;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 72px;
}

.dashboard-stat-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: #8a7a5c;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0 0 0.35rem 0;
  line-height: 1.3;
}

.dashboard-stat-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: #c9b896;
  line-height: 1.2;
}

.dashboard-stat-footer {
  flex-shrink: 0;
  padding: 0.6rem 1rem;
  border-top: 1px solid rgba(139, 105, 20, 0.3);
  font-size: 0.75rem;
  color: #8a7a5c;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
}

.dashboard-stat-footer i {
  color: #8b6914;
}

.dashboard-stat-footer-icon {
  max-height: 1rem;
  width: auto;
  object-fit: contain;
}

.dashboard-stat-footer-text {
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.vocation-row {
  margin-bottom: 1.5rem;
}

.vocation-section-card {
  background: linear-gradient(180deg, #2a2520 0%, #1c1916 100%);
  border: 2px solid #8b6914;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(139, 105, 20, 0.2);
  padding: 1.25rem;
}

.vocation-section-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #d4af37;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0 0 1rem 0;
  text-align: center;
}

.vocation-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
}

@media (min-width: 576px) {
  .vocation-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 768px) {
  .vocation-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 992px) {
  .vocation-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 1200px) {
  .vocation-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

.vocation-card {
  background: linear-gradient(180deg, #2a2520 0%, #1c1916 100%);
  border: 2px solid #8b6914;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(139, 105, 20, 0.2);
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.vocation-card-header {
  padding: 1rem 1rem 0.5rem;
  text-align: center;
  background: linear-gradient(180deg, rgba(139, 105, 20, 0.15) 0%, transparent 100%);
  border-bottom: 1px solid rgba(139, 105, 20, 0.4);
}

.vocation-sprite {
  display: block;
  margin: 0 auto 0.5rem;
  image-rendering: pixelated;
  image-rendering: -moz-crisp-edges;
  image-rendering: crisp-edges;
  width: 80px;
  height: 80px;
  object-fit: contain;
  object-position: center center;
}

.vocation-name {
  font-size: 1rem;
  font-weight: 700;
  color: #d4af37;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
  text-shadow: 0 0 8px rgba(212, 175, 55, 0.4);
}

.vocation-card-body {
  padding: 1rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.vocation-stat {
  text-align: center;
}

.vocation-stats-main {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  flex: 1;
}

.vocation-stats-main .vocation-stat {
  flex: 1;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 0.75rem 0.5rem;
  border: 1px solid rgba(139, 105, 20, 0.35);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.vocation-stat-tag {
  display: block;
  font-size: 0.65rem;
  font-weight: 700;
  color: #8b6914;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 0.25rem;
}

.vocation-stat-value-main {
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.2;
}

.vocation-stats-main .vocation-stat.rubini-coins .vocation-stat-value-main {
  color: #d4af37;
}

.vocation-stats-main .vocation-stat.level .vocation-stat-value-main {
  color: #7eb8da;
}

.vocation-stat-sublabel {
  display: block;
  font-size: 0.6rem;
  color: #8a7a5c;
  margin-top: 0.2rem;
  line-height: 1.2;
}

.vocation-sold {
  text-align: center;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  border: 1px solid rgba(139, 105, 20, 0.25);
  display: inline-flex;
  align-items: baseline;
  gap: 0.35rem;
  align-self: center;
}

.vocation-sold-value {
  font-size: 1rem;
  font-weight: 600;
  color: #c9b896;
}

.vocation-sold-label {
  font-size: 0.7rem;
  color: #8a7a5c;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.stats-coin-icon {
  max-height: 2.5rem;
  width: auto;
  object-fit: contain;
  vertical-align: middle;
}

.stats-coin-icon-footer {
  max-height: 1rem;
  width: auto;
  object-fit: contain;
  vertical-align: middle;
  margin-right: 0.25rem;
}

.vocation-coin-icon {
  display: inline-block;
  max-height: 1rem;
  width: auto;
  object-fit: contain;
  vertical-align: middle;
  margin-right: 0.25rem;
}

.vocation-stat.rubini-coins .vocation-stat-value {
  color: #d4af37;
}

.vocation-stat.level .vocation-stat-value {
  color: #7eb8da;
}

/* Records card */
.records-row {
  margin-bottom: 1.5rem;
}

.records-card {
  background: linear-gradient(180deg, #2a2520 0%, #1c1916 100%);
  border: 2px solid #8b6914;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(139, 105, 20, 0.2);
  padding: 1.25rem;
}

.records-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #d4af37;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0 0 1rem 0;
  text-align: center;
}

.records-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
}

@media (min-width: 576px) {
  .records-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 992px) {
  .records-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1200px) {
  .records-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

.record-item {
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(139, 105, 20, 0.35);
  border-radius: 6px;
  padding: 1rem;
  min-height: 120px;
}

.record-item.record-empty {
  display: flex;
  align-items: center;
  justify-content: center;
}

.record-label {
  font-size: 0.7rem;
  font-weight: 700;
  color: #8b6914;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.35rem;
}

.record-placeholder {
  color: #8a7a5c;
}

.record-name {
  font-size: 1rem;
  font-weight: 600;
  color: #e8dcc8;
  margin-bottom: 0.25rem;
}

.record-meta {
  font-size: 0.75rem;
  color: #8a7a5c;
  margin-bottom: 0.5rem;
}

.record-price {
  font-size: 0.95rem;
  font-weight: 600;
  color: #d4af37;
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.record-coin-icon {
  max-height: 1rem;
  width: auto;
  object-fit: contain;
}

.record-skill {
  font-size: 0.8rem;
  color: #7eb8da;
  margin-top: 0.35rem;
}

</style>
